import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';
import { Checkbox } from '@comparethemarketau/manor-checkbox';

import { withProductCompareAction } from './with_product_compare_action';
import { withQuoteFlatten } from './with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        height: '100%'
    },
    toggle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: theme.spacing[68]
    },
    label: {
        color: theme.colors.primary500,
        fontSize: theme.fontSize.xs,
        lineHeight: theme.lineHeight.tight
    },
    checkbox: {
        marginBottom: theme.spacing[4],
        minWidth: 'unset'
    },
    onSelected: {
        backgroundColor: theme.colors.primary50
    },
    unClickable: {
        cursor: 'not-allowed'
    },
    clickable: {
        cursor: 'pointer'
    }
}));

const _CompareCheckbox = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { productId, providerCode, isSelected, isDisabled, onCompareClick } = props;

    const handleClick = (e) => {
        if (e.preventDefault) {
            e.preventDefault();
        }
        onCompareClick();
    };

    return (
        <div className={classNames('test-policyProductCard-compareCheckbox', classes.container, isSelected && classes.onSelected)}>
            <div
                className={classNames(classes.toggle, isDisabled ? classes.unClickable : classes.clickable)}
                onClick={handleClick}
                role="button"
                tabIndex={0}
            >
                <Checkbox
                    id={`checkbox-compare-${providerCode}-${productId}`}
                    handleChange={handleClick}
                    isSelected={isSelected}
                    disabled={isDisabled}
                    trackingLabel={`Compare product: ${providerCode} - ${productId}`}
                    className={classes.checkbox}
                />
                <Typography className={classes.label}>Compare</Typography>
            </div>
        </div>
    );
};

_CompareCheckbox.propTypes = {
    quote: PropTypes.object,
    productId: PropTypes.string.isRequired,
    providerCode: PropTypes.string,

    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,

    onCompareClick: PropTypes.func
};

const CompareCheckbox = withQuoteFlatten(withProductCompareAction(_CompareCheckbox));

export { CompareCheckbox, _CompareCheckbox };
